import _ from 'underscore';
import $ from 'jquery';

import { a11yPlugin } from '@bingads-webui/projection-grid-a11y';
import { uiBlockerPlugin } from '@bingads-webui/projection-grid-uiblocker';
import { paginationPlugin } from '@bingads-webui/projection-grid-pagination';
import { uncheckedInjectionContext as globalContext } from '@bingads-webui-campaign/injection-context';
import { inlineDownloadWithoutFilterstateAndSegmentPlugin } from '@bingads-webui-campaign/projection-grid-inline-download';
import { columnChooserPlugin } from '@bingads-webui-campaign/projection-grid-column-chooser';
import { jsdataRawDataPlugin } from '@bingads-webui-campaign/pgrid-js-data-raw-data';
import { perfMarkerPlugin } from '@bingads-webui-campaign/pgrid-performance-log';
import { inlineErrorPlugin } from '@bingads-webui/projection-grid-inline-error';
import { dateFilterPlugin } from '@bingads-webui-campaign/projection-grid-date-filter';
import { getPGridColumnResizePlugin } from '@bingads-webui-campaign/projection-grid-column-resize-helper';

const appState = globalContext.require('component/state/index');
const edm = globalContext.requireDefault('component/edm-campaign/index');
const appConfig = globalContext.require('component/config/index');
const { Columns, SelectedColumns } = globalContext.require('component/bingads-grid/service/column-chooser-preferences');
const { LegacyColumns, LegacySelectedColumns } = globalContext.require('component/bingads-grid/service/legacy-column-chooser-preferences');
const { CustomColumns } = globalContext.require('component/bingads-grid/service/custom-column-preferences');
const { LegacyGridFlag } = globalContext.require('component/bingads-grid/service/legacy-grid-flag-preferences');
const { DownloadView } = globalContext.require('campaignui/feature/griddownload/view/adapter');
const i18n = globalContext.require('@bingads-webui/i18n-amd-loader!campaignui/feature/dimension');

const permissions = appConfig.get('Permissions');

export function getBaseDimensionPlugins({
  gridName,
  isForVNext,
  addDateChangeListener,
  p$daterange,
  columnChooserConfig,
  perfMarker,
  reportSchema,
  preferenceService,
  columnConversions,
}) {
  let isLabelsGrid = false;
  const modifiedReportSchemaForLabelsDownload = _.clone(reportSchema);
  if (reportSchema.name.indexOf('Label') !== -1) {
    isLabelsGrid = true;
    modifiedReportSchemaForLabelsDownload.name = 'DimensionRow';
  }


  return _.compact([{
    plugin: perfMarkerPlugin,
    config: {
      appConfig,
      marker: perfMarker,
    },
  }, {
    plugin: a11yPlugin,
    config: { i18n },
  }, {
    plugin: uiBlockerPlugin,
    config: { el: $(isForVNext ? '.dimensions-page' : '#summaryEntityPanel') },
  }, {
    plugin: paginationPlugin,
    config: {
      availablePageSizes: [20, 50, 100, 200],
      enableRandomPage: false,
      pageNumberLabelText: isForVNext ? '' : i18n.getString('Grid_Page_Number_Label_Text'),
      pageSizeText: i18n.getString('Grid_ShowRows'),
      totalPageCountText: i18n.getString('Grid_PageOf'),
      resetPageNumberOnSort: true,
    },
  }, {
    plugin: inlineDownloadWithoutFilterstateAndSegmentPlugin,
    config: {
      isAvailable: true,
      schema: modifiedReportSchemaForLabelsDownload,
      gridId: '',
      p$daterange,
      DownloadView,
      i18n,
      processReportRule: (ReportRule) => {
        if (isLabelsGrid) {
          let queryString = ReportRule.Selection.QueryString;
          if (ReportRule.Headers.length === 1) {
            queryString = queryString.replace(',LabelColorCode', '');
          } else {
            queryString = queryString.replace('LabelColorCode,', '');
          }
          return _.defaults({
            Selection: _.defaults({
              '@odata.type': '#Model.DimensionReportSelection',
              Locale: 1,
              Type: reportSchema.name,
              QueryString: queryString,
            }, ReportRule.Selection),
          }, ReportRule);
        }
        return ReportRule;
      },
      ReportEmailRule: (() => {
        const ReportEmailRule = appState.get('$ReportEmailRule');
        appState.unset('$ReportEmailRule');
        return ReportEmailRule;
      })(),
    },
  }, {
    plugin: columnChooserPlugin,
    config: _.extend(columnChooserConfig, {
      Columns,
      SelectedColumns,
      LegacyColumns,
      LegacySelectedColumns,
      LegacyGridFlag,
      nameFromLegacy: {},
      CustomColumns,
      customColumnConfig: { enabled: false },
      isForVNext,
      i18n,
      columnConversions,
    }),
  }, {
    plugin: dateFilterPlugin,
    config: {
      state: appState,
      isOdataActionSource: false,
      edm,
      addDateChangeListener,
      comparisonColumns: [
        'PeriodPerformanceMetrics',
        'PerformanceMetricsChange',
        'PerformanceMetricsChangePercentage',
      ],
      p$daterange,
    },
  },
  {
    plugin: jsdataRawDataPlugin,
  },
  {
    plugin: inlineErrorPlugin({
      errorIconClasses: ['grid-error'],
    }),
  },
  getPGridColumnResizePlugin({
    gridName,
    preferenceService,
    permissions,
  }),
  ]);
}
